module.exports = __webpack_public_path__ + "static/media/model-pajero-91.184de750.jpg";